<template>
    <b-row>
        <b-col sm="12">
            <b-card no-body>
                <b-tabs card class="nav-fill">
                    <b-tab title="문의내역">
                        <UserQnaList v-bind:userId="userId" />
                    </b-tab>
                    <b-tab title="주문내역">
                        <UserOrderList v-bind:userId="userId" />
                    </b-tab>
                    <b-tab title="쿠폰이력">
                        <UserCouponList v-bind:userId="userId" />
                    </b-tab>
                    <b-tab title="로그인이력">
                        <UserLoginHistList v-bind:userId="userId" />
                    </b-tab>
                    <b-tab title="구독회원정보">
                        <UserCompanyDetail v-bind:userId="userId" />
                    </b-tab>
                    <b-tab title="구독회원가입이력">
                        <UserCompanyList v-bind:userId="userId" />
                    </b-tab>
                    <b-tab title="권한KEY관리">
                        <UserAuthKeyDetail v-bind:userId="userId" />
                    </b-tab>
                </b-tabs>
            </b-card>
        </b-col>
    </b-row>
</template>
<script>
import UserQnaList from './tabs/qna/UserQnaList';
import UserOrderList from './tabs/order/UserOrderList';
import UserCouponList from './tabs/coupon/UserCouponList';
import UserLoginHistList from './tabs/loginHistory/UserLoginHistList';
// import UserCompanyDetail from './tabs/company/UserCompanyDetail';
import UserCompanyDetail from '../../common/UserCompanyDetail';
import UserCompanyList from './tabs/company/UserCompanyList';
import UserAuthKeyDetail from './tabs/authKey/UserAuthKeyDetail';

export default {
    name: "userTabs",
    props: {
        userId: {
            type: String,
            default: ""
        },
    },
    components: {
        UserQnaList,
        UserOrderList,
        UserCouponList,
        UserLoginHistList,
        UserCompanyDetail,
        UserCompanyList,
        UserAuthKeyDetail,
    }
}
</script>
<style lang="css" scoped>
table.b-table thead th.thClass_w08 { width: 8%; border-right: 1px solid #a4b7c1; text-align: center; }
table.b-table thead th.thClass_w10 { width: 10%; border-right: 1px solid #a4b7c1; text-align: center; }
table.b-table thead th.thClass_w12 { width: 12%; border-right: 1px solid #a4b7c1; text-align: center; }
table.b-table thead th.thClass_w15 { width: 15%; border-right: 1px solid #a4b7c1; text-align: center; }
table.b-table thead th.thClass_w20 { width: 20%; border-right: 1px solid #a4b7c1; text-align: center; }
table.b-table thead th.thClass_w33 { width: 33%; border-right: 1px solid #a4b7c1; text-align: center; }
table.b-table thead th.thClass_w50 { width: 50%; border-right: 1px solid #a4b7c1; text-align: center; }
table.b-table thead th.thClass_other { width: 44%; border-right: 1px solid #a4b7c1; text-align: center; }
table.b-table tbody td.tdClass {
    cursor: pointer; 
    border-right: 1px solid #a4b7c1;
}
table.b-table tbody td.textAlignCenter {
    cursor: pointer; 
    border-right: 1px solid #a4b7c1;
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/views/user/userDetail/component/UserTabs.vue